import { useLocalStorage, useWalletConnection } from '@/hooks';
import { TSetState } from '@/types/TSetState';
import { createContext, useContext, useEffect, useState } from 'react';

interface NewUpdateProps {
  show: boolean;
  message: string;
}

interface NewUpdateContextProps extends NewUpdateProps {
  setData: TSetState<NewUpdateProps>;
  showMessage: (v: boolean) => void;
}

const NewUpdateContext = createContext<NewUpdateContextProps | undefined>(
  undefined
);

export const NewUpdateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [newUpdate, setNewUpdate] = useLocalStorage('newUpdate', {
    show: true,
    message: '',
  });

  const [data, setData] = useState<NewUpdateProps>({
    show: false,
    message:
      'Starting from this cycle, each match will be formed based on a 5-gram balance threshold. Ensure your sides are balanced accordingly to qualify for matching',
  });

  const showMessage = (value: boolean) => {
    setNewUpdate((prev) => ({ ...prev, show: value }));
    setData((prev) => ({ ...prev, show: value }));
  };

  useEffect(() => {
    if (newUpdate) setData(newUpdate);
  }, []);

  return (
    <NewUpdateContext.Provider value={{ ...data, setData, showMessage }}>
      {children}
    </NewUpdateContext.Provider>
  );
};

export const useNewUpdateContext = () => {
  const context = useContext(NewUpdateContext);
  if (!context)
    throw new Error(
      'useNewUpdateContext must be used within a NewUpdateProvider'
    );
  return context;
};
